<div class="flex flex-column">
    <app-social-billing-status-widget [folderId]="folderId()" [showHeader]="false"></app-social-billing-status-widget>
    <app-social-billing-unbilled-works-widget [folderId]="folderId()"></app-social-billing-unbilled-works-widget>
</div>
